module.exports = __webpack_public_path__ + "img/9 (2).99e73e84.jpg";